// Llamora — scripts propios (vanilla JS, sin librerias externas)

function mtInitReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function mtInitComparadores() {
  var comparadores = document.querySelectorAll('.mt-comparador');
  comparadores.forEach(function (comp) {
    var asa = comp.querySelector('.mt-comparador-asa');
    if (!asa) return;
    var dragging = false;

    function setSplit(clientX) {
      var rect = comp.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      comp.style.setProperty('--mt-split', pct + '%');
    }

    function onDown(e) {
      dragging = true;
      setSplit((e.touches ? e.touches[0].clientX : e.clientX));
    }
    function onMove(e) {
      if (!dragging) return;
      setSplit((e.touches ? e.touches[0].clientX : e.clientX));
    }
    function onUp() { dragging = false; }

    asa.addEventListener('mousedown', onDown);
    asa.addEventListener('touchstart', onDown, { passive: true });
    window.addEventListener('mousemove', onMove);
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchend', onUp);
    comp.addEventListener('click', function (e) {
      if (e.target === asa) return;
      setSplit(e.clientX);
    });
  });
}

function mtInitMarquee() {
  var marquees = document.querySelectorAll('[data-mt-marquee]');
  marquees.forEach(function (marquee) {
    var track = marquee.querySelector('.mt-marquee-track');
    if (!track) return;
    var velocidad = parseFloat(marquee.getAttribute('data-mt-marquee-velocidad')) || 35;
    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mitad = track.scrollWidth / 2;
    window.addEventListener('resize', function () { mitad = track.scrollWidth / 2; });

    if (reducido) return;

    var pausado = false;
    var ultimoTs = null;
    var pos = 0;

    function tick(ts) {
      requestAnimationFrame(tick);
      mitad = track.scrollWidth / 2;
      if (pausado || mitad <= 0) {
        ultimoTs = null;
        pos = marquee.scrollLeft;
        return;
      }
      if (ultimoTs != null) {
        pos += (mitad / velocidad) * Math.min((ts - ultimoTs) / 1000, 0.1);
        if (pos >= mitad) pos -= mitad;
        marquee.scrollLeft = pos;
      }
      ultimoTs = ts;
    }
    requestAnimationFrame(tick);

    marquee.addEventListener('scroll', function () {
      if (mitad <= 0) return;
      if (marquee.scrollLeft >= mitad) marquee.scrollLeft -= mitad;
      else if (marquee.scrollLeft < 0) marquee.scrollLeft += mitad;
    });

    var arrastrando = false;
    var startX = 0;
    var startScroll = 0;

    function onDown(e) {
      pausado = true;
      marquee.classList.add('mt-marquee-arrastrando');
      arrastrando = true;
      startX = e.clientX;
      startScroll = marquee.scrollLeft;
    }
    function onMove(e) {
      if (!arrastrando) return;
      e.preventDefault();
      marquee.scrollLeft = startScroll - (e.clientX - startX);
    }
    function onUp() {
      if (!arrastrando) return;
      arrastrando = false;
      marquee.classList.remove('mt-marquee-arrastrando');
      setTimeout(function () { pausado = false; }, 600);
    }

    marquee.addEventListener('mousedown', onDown);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    marquee.addEventListener('touchstart', function () { pausado = true; }, { passive: true });
    marquee.addEventListener('touchend', function () { setTimeout(function () { pausado = false; }, 1500); }, { passive: true });
  });
}

function mtInitCifras() {
  var cifras = document.querySelectorAll('.mt-cifra[data-hasta]');
  if (!cifras.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var hasta = parseFloat(el.getAttribute('data-hasta'));
      var decimales = el.getAttribute('data-decimales') === '1';
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = hasta * (1 - Math.pow(1 - progreso, 3));
        el.textContent = decimales ? valor.toFixed(1) : Math.round(valor);
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = decimales ? hasta.toFixed(1) : hasta;
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  cifras.forEach(function (el) { obs.observe(el); });
}

function mtInitGaleriaProducto() {
  var galerias = document.querySelectorAll('.mt-galeria');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('.mt-galeria-principal img');
    var thumbs = galeria.querySelectorAll('.mt-galeria-thumb');
    if (!principal || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        principal.setAttribute('src', full);
        thumbs.forEach(function (t) { t.classList.remove('mt-activo'); });
        thumb.classList.add('mt-activo');
      });
    });
  });
}

function mtInitSeguroEnvio() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var regaloId = form.getAttribute('data-mt-regalo-variant');
    var checkbox = form.querySelector('[data-mt-seguro-checkbox]');
    if (!regaloId && !checkbox && !form.querySelector('[data-mt-extra-checkbox]')) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var idInput = form.querySelector('input[name="id"]');
      var cantidadInput = form.querySelector('[data-mt-cantidad-input]');
      var boton = form.querySelector('[data-mt-boton-comprar]');
      var items = [
        { id: idInput.value, quantity: parseInt((cantidadInput && cantidadInput.value) || 1, 10) }
      ];
      var nota = form.querySelector('textarea[name="properties[Mensaje de regalo]"]');
      var destino = form.querySelector('input[name="properties[Comprado para]"]:checked');
      if (nota && nota.value) items[0].properties = Object.assign({}, items[0].properties, { 'Mensaje de regalo': nota.value });
      if (destino) items[0].properties = Object.assign({}, items[0].properties, { 'Comprado para': destino.value });

      if (regaloId) items.push({ id: regaloId, quantity: 1 });
      if (checkbox && checkbox.checked) items.push({ id: checkbox.value, quantity: 1 });
      var extra = form.querySelector('[data-mt-extra-checkbox]');
      if (extra && extra.checked) {
        var extraItem = { id: extra.value, quantity: 1 };
        if (extra.getAttribute('data-aromas')) extraItem.properties = { 'Aromas': extra.getAttribute('data-aromas') };
        items.push(extraItem);
      }

      if (boton) boton.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart add failed'); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          if (boton) boton.disabled = false;
          form.submit();
        });
    });
  });
}

function mtInitCruzada() {
  document.querySelectorAll('[data-mt-cruzada]').forEach(function (bloque) {
    var boton = bloque.querySelector('[data-mt-cruzada-anadir]');
    var variante = bloque.querySelector('[data-mt-cruzada-variante]');
    if (!boton) return;

    var media = bloque.querySelector('[data-mt-cruzada-media] img');
    var precioEl = bloque.querySelector('[data-mt-cruzada-precio]');

    if (variante && variante.tagName === 'SELECT') {
      variante.addEventListener('change', function () {
        var opcion = variante.options[variante.selectedIndex];
        var imagen = opcion.getAttribute('data-imagen');
        var precio = opcion.getAttribute('data-precio');
        if (media && imagen) media.setAttribute('src', imagen);
        if (precioEl && precio) precioEl.textContent = precio;
      });
    }

    boton.addEventListener('click', function () {
      var id = variante ? variante.value : null;
      if (!id) return;
      boton.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart add failed'); return r.json(); })
        .then(function () {
          if (bloque.hasAttribute('data-mt-cruzada-recargar')) {
            window.location.reload();
            return;
          }
          boton.textContent = boton.getAttribute('data-texto-hecho');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () {
            boton.textContent = boton.getAttribute('data-texto-normal');
            boton.disabled = false;
          }, 2500);
        })
        .catch(function () {
          boton.disabled = false;
        });
    });
  });
}

function mtInitOtrosAromas() {
  document.querySelectorAll('[data-mt-otro-anadir]').forEach(function (boton) {
    boton.addEventListener('click', function () {
      var id = boton.getAttribute('data-variant-id');
      if (!id) return;
      boton.disabled = true;
      var items = [{ id: id, quantity: 1 }];
      var regaloId = boton.getAttribute('data-regalo-id');
      if (regaloId) items.push({ id: regaloId, quantity: 1 });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart add failed'); return r.json(); })
        .then(function () {
          if (boton.hasAttribute('data-mt-ir-carrito')) window.location.href = '/cart';
          else window.location.reload();
        })
        .catch(function () {
          boton.disabled = false;
        });
    });
  });
}

function mtInitSeguroCarrito() {
  var check = document.querySelector('[data-mt-seguro-carrito]');
  if (!check) return;
  check.addEventListener('change', function () {
    var id = check.getAttribute('data-variant-id');
    check.disabled = true;
    var peticion = check.checked
      ? fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
      : fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 0 })
        });
    peticion
      .then(function (r) { if (!r.ok) throw new Error('cart change failed'); return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () {
        check.disabled = false;
        check.checked = !check.checked;
      });
  });
}

function mtInitVariantes() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var inputs = form.querySelectorAll('[data-mt-opcion]');
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-mt-precio]');
    var precioComparadoEl = form.querySelector('[data-mt-precio-comparado]');
    var boton = form.querySelector('[data-mt-boton-comprar]');

    function moneda(centavos) {
      return (centavos / 100).toLocaleString('es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
    }

    function actualizar() {
      var seleccion = [];
      inputs.forEach(function (input) {
        if (input.type === 'radio' && !input.checked) return;
        seleccion.push(input.value);
      });
      var variante = variantes.find(function (v) {
        return v.options.length === seleccion.length && v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;
      if (idInput) idInput.value = variante.id;
      if (variante.imagen) {
        var galeria = form.closest('.mt-producto-layout') ? form.closest('.mt-producto-layout').querySelector('.mt-galeria') : document.querySelector('.mt-galeria');
        var principal = galeria && galeria.querySelector('.mt-galeria-principal img');
        if (principal) principal.setAttribute('src', variante.imagen);
        if (galeria) {
          var colorMarcado = form.querySelector('[data-mt-color-filtro]:checked');
          var todosLosThumbs = galeria.querySelectorAll('.mt-galeria-thumb');
          todosLosThumbs.forEach(function (t) {
            t.classList.remove('mt-activo');
            if (colorMarcado) t.hidden = t.getAttribute('data-color') !== colorMarcado.value;
          });
          var thumbCoincide = galeria.querySelector('.mt-galeria-thumb[data-full="' + variante.imagen + '"]');
          if (thumbCoincide) {
            thumbCoincide.hidden = false;
            thumbCoincide.classList.add('mt-activo');
          } else {
            var primerVisible = galeria.querySelector('.mt-galeria-thumb:not([hidden])');
            if (primerVisible) primerVisible.classList.add('mt-activo');
          }
        }
      }
      if (precioEl) precioEl.textContent = moneda(variante.price);
      if (precioComparadoEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioComparadoEl.textContent = moneda(variante.compare_at_price);
          precioComparadoEl.hidden = false;
        } else {
          precioComparadoEl.hidden = true;
        }
      }
      if (boton) {
        boton.disabled = !variante.available;
        boton.querySelector('[data-mt-boton-texto]').textContent = variante.available
          ? boton.getAttribute('data-texto-disponible')
          : boton.getAttribute('data-texto-agotado');
      }
    }

    inputs.forEach(function (input) { input.addEventListener('change', actualizar); });
    actualizar();
  });
}

function mtInitCuentaAtras() {
  var barras = document.querySelectorAll('[data-mt-urgencia]');
  barras.forEach(function (barra) {
    var hasta;
    if (barra.hasAttribute('data-hasta-lunes')) {
      var ahora = new Date();
      var diasHastaLunes = (8 - ahora.getDay()) % 7;
      if (diasHastaLunes === 0) diasHastaLunes = 7;
      hasta = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate() + diasHastaLunes, 0, 0, 0);
    } else {
      hasta = new Date(barra.getAttribute('data-hasta'));
    }
    var diasEl = barra.querySelector('[data-mt-dias]');
    var horasEl = barra.querySelector('[data-mt-horas]');
    var minEl = barra.querySelector('[data-mt-min]');
    var segEl = barra.querySelector('[data-mt-seg]');
    if (!diasEl || isNaN(hasta.getTime())) return;

    function pad(n) { return String(n).padStart(2, '0'); }

    function actualizar() {
      var restante = hasta.getTime() - Date.now();
      if (restante <= 0) {
        diasEl.textContent = '00'; horasEl.textContent = '00'; minEl.textContent = '00'; segEl.textContent = '00';
        return;
      }
      var dias = Math.floor(restante / 86400000);
      var horas = Math.floor((restante % 86400000) / 3600000);
      var min = Math.floor((restante % 3600000) / 60000);
      var seg = Math.floor((restante % 60000) / 1000);
      diasEl.textContent = pad(dias);
      horasEl.textContent = pad(horas);
      minEl.textContent = pad(min);
      segEl.textContent = pad(seg);
    }
    actualizar();
    setInterval(actualizar, 1000);
  });
}

function mtInitRegalo() {
  var toggles = document.querySelectorAll('[data-mt-regalo-toggle]');
  toggles.forEach(function (toggle) {
    var panel = document.querySelector(toggle.getAttribute('data-target'));
    if (!panel) return;
    toggle.addEventListener('change', function () {
      if (toggle.type === 'checkbox') {
        panel.hidden = !toggle.checked;
      } else {
        panel.hidden = !(toggle.checked && toggle.getAttribute('data-mt-mostrar') === 'true');
      }
    });
  });
}

function mtInitCantidad() {
  document.querySelectorAll('[data-mt-cantidad-input]').forEach(function (input) {
    var menos = input.parentElement.querySelector('[data-mt-cantidad-menos]');
    var mas = input.parentElement.querySelector('[data-mt-cantidad-mas]');
    if (menos) menos.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    if (mas) mas.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
}

// Varias secciones incluyen este archivo (barra superior + la de cada página):
// sin esta guarda los botones reaccionan dos veces y añaden todo por duplicado.
if (!window.mtScriptsIniciado) document.addEventListener('DOMContentLoaded', function () {
  mtInitReveal();
  mtInitComparadores();
  mtInitMarquee();
  mtInitCifras();
  mtInitGaleriaProducto();
  mtInitVariantes();
  mtInitSeguroEnvio();
  mtInitSeguroCarrito();
  mtInitCruzada();
  mtInitOtrosAromas();
  mtInitCuentaAtras();
  mtInitRegalo();
  mtInitCantidad();
});
window.mtScriptsIniciado = true;
